import { CHART_DEFAULTS, CHARTS } from 'vio-constants';
import { get } from 'vio-libs';
import { isShelterRetrofit, isVEM150A2, isVEM180, isVEM20 } from '../../lib';
export function getAirflowChart(chartOptions) {
    return getSiteChart(chartOptions, CHARTS.AIRFLOW);
}
function getLockerNetworkCharts(chartOptions, readingType, organization) {
    const window = chartOptions.window || CHART_DEFAULTS.WINDOW;
    const step = chartOptions.step || CHART_DEFAULTS.STEP;
    const rateInterval = chartOptions.rateInterval || 1;
    const location = chartOptions.locationSlug;
    const { locker } = chartOptions;
    return get(`locker-network-charts?organization=${organization}&location=${location}&locker=${locker}&reading_type=${readingType}&window=${window}&step=${step}&function=rate&rate_interval=${rateInterval}`);
}
function getLockerPowerConsumptionChart(chartOptions, organization) {
    const window = chartOptions.window || CHART_DEFAULTS.WINDOW;
    const location = chartOptions.locationSlug;
    const locker = chartOptions.locker.toLowerCase();
    return get(`locker-power-charts?organization=${organization}&location=${location}&locker=${locker}&window=${window}`);
}
function getSiteChart(chartOptions, readingType) {
    const window = chartOptions.window || CHART_DEFAULTS.WINDOW;
    const step = chartOptions.step || CHART_DEFAULTS.STEP;
    const { deployedHardware, locationSlug: location, rackId } = chartOptions;
    if (rackId) {
        return get(`site-charts?location=${location}&reading_type=${readingType}&device_location=r${rackId}&window=${window}&step=${step}`);
    }
    if (readingType === CHARTS.AIRFLOW) {
        return get(`site-charts?location=${location}&reading_type=speed&device_type=${readingType}&window=${window}&step=${step}`);
    }
    if (readingType === CHARTS.POWER) {
        if (isVEM20(deployedHardware)) {
            return get(`site-charts?location=${location}&reading_type=${readingType}&device_info_regex=total it load instantaneous.*&window=${window}&step=${step}&unit_name=watt`);
        }
        return get(`site-charts?location=${location}&reading_type=${readingType}&device_info_regex=.*total.*&window=${window}&step=${step}&unit_name=watt`);
    }
    if (readingType === CHARTS.HUMIDITY) {
        if (isVEM150A2(deployedHardware) || isVEM180(deployedHardware)) {
            return get(`site-charts?location=${location}&reading_type=percentage&device_info_regex=.*system humidity.*&window=${window}&step=${step}&unit_name=percent`);
        }
        if (isVEM20(deployedHardware) || isShelterRetrofit(deployedHardware)) {
            return get(`site-charts?location=${location}&reading_type=percentage&device_info_regex=network humidity.*&window=${window}&step=${step}&unit_name=percent`);
        }
    }
    if (readingType === CHARTS.TEMPERATURE) {
        if (isVEM150A2(deployedHardware) || isVEM180(deployedHardware)) {
            return get(`site-charts?location=${location}&reading_type=${readingType}&device_info_regex=.*system temperature.*&window=${window}&step=${step}&unit_name=celsius`);
        }
        if (isVEM20(deployedHardware) || isShelterRetrofit(deployedHardware)) {
            return get(`site-charts?location=${location}&reading_type=${readingType}&device_info_regex=network temperature.*&window=${window}&step=${step}&unit_name=celsius`);
        }
    }
    return get(`site-charts?location=${location}&reading_type=${readingType}&window=${window}&step=${step}`);
}
function getSiteNetworkCharts(chartOptions, readingType, organization) {
    const window = chartOptions.window || CHART_DEFAULTS.WINDOW;
    const step = chartOptions.step || CHART_DEFAULTS.STEP;
    const rateInterval = chartOptions.rateInterval || 1;
    const location = chartOptions.locationSlug;
    return get(`site-network-charts?organization=${organization}&location=${location}&reading_type=${readingType}&window=${window}&step=${step}&function=rate&rate_interval=${rateInterval}`);
}
function getInterfaceChart(chartOptions, readingType, organization) {
    const window = chartOptions.window || CHART_DEFAULTS.WINDOW;
    const step = chartOptions.step || CHART_DEFAULTS.STEP;
    const rateInterval = chartOptions.rateInterval || 1;
    const { interfaceName, locationSlug: location, systemId } = chartOptions;
    return get(`interface-charts?organization=${organization}&location=${location}&interface_name=${interfaceName}&system_id=${systemId}&reading_type=${readingType}&window=${window}&step=${step}&function=rate&rate_interval=${rateInterval}`);
}
export function getEgressInterfaceChart(chartOptions, organization) {
    return getInterfaceChart(chartOptions, CHARTS.EGRESS_OCTETS, organization);
}
export function getEgressLockerCharts(chartOptions, organization) {
    return getLockerNetworkCharts(chartOptions, CHARTS.EGRESS_OCTETS, organization);
}
export function getEgressSiteCharts(chartOptions, organization) {
    return getSiteNetworkCharts(chartOptions, CHARTS.EGRESS_OCTETS, organization);
}
export function getHumidityChart(chartOptions) {
    return getSiteChart(chartOptions, CHARTS.HUMIDITY);
}
export function getIngressInterfaceChart(chartOptions, organization) {
    return getInterfaceChart(chartOptions, CHARTS.INGRESS_OCTETS, organization);
}
export function getIngressLockerCharts(chartOptions, organization) {
    return getLockerNetworkCharts(chartOptions, CHARTS.INGRESS_OCTETS, organization);
}
export function getIngressSiteCharts(chartOptions, organization) {
    return getSiteNetworkCharts(chartOptions, CHARTS.INGRESS_OCTETS, organization);
}
export function getPowerConsumptionChart(chartOptions, organization) {
    if (organization && (chartOptions === null || chartOptions === void 0 ? void 0 : chartOptions.locker)) {
        return getLockerPowerConsumptionChart(chartOptions, organization);
    }
    return getSiteChart(chartOptions, CHARTS.POWER);
}
export function getPressureChart(chartOptions) {
    return getSiteChart(chartOptions, CHARTS.PRESSURE);
}
export function getTemperatureChart(chartOptions) {
    return getSiteChart(chartOptions, CHARTS.TEMPERATURE);
}
